import { render, staticRenderFns } from "./AreaPackView.vue?vue&type=template&id=65436cba&scoped=true"
import script from "./AreaPackView.vue?vue&type=script&lang=js"
export * from "./AreaPackView.vue?vue&type=script&lang=js"
import style0 from "./AreaPackView.vue?vue&type=style&index=0&id=65436cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65436cba",
  null
  
)

export default component.exports